// Webpack entry point — bundles styles, runtime, and PWA registration.
import "../css/index.css";
import "./app.js";
import "./common/ui.js";
import "./register-sw.js";

document.addEventListener("DOMContentLoaded", () => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const toastEl = $("[data-toast]");
  const toast = (m) => {
    if (!toastEl) return;
    toastEl.textContent = m;
    toastEl.classList.add("is-show");
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toastEl.classList.remove("is-show"), 1200);
  };

  // ─── Logo entrance ───
  const logo = $("[data-logo]");
  if (logo) {
    logo.style.opacity = "0";
    logo.style.transform = "scale(.6)";
    logo.style.transition =
      "opacity .5s ease, transform .55s cubic-bezier(.22,1,.36,1)";
    requestAnimationFrame(() => {
      logo.style.opacity = "1";
      logo.style.transform = "scale(1)";
    });
  }

  // ─── Reveal entrance for title, progress bar, CTA ───
  $$(".reveal").forEach((el, i) => {
    setTimeout(() => el.classList.add("is-in"), 300 + i * 120);
  });

  // ─── Bottom sheets (data-sheet-open / data-sheet-close) ───
  const openSheet = (sheet) => {
    if (!sheet) return;
    sheet.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };
  const closeSheet = (sheet) => {
    if (!sheet) return;
    sheet.classList.remove("is-open");
    document.body.style.overflow = "";
  };
  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-sheet-open]");
    if (opener) {
      e.preventDefault();
      const id = opener.getAttribute("data-sheet-open");
      openSheet(document.getElementById(id));
      return;
    }
    if (e.target.closest("[data-sheet-close]") || e.target.matches(".sheet-backdrop")) {
      const sheet = e.target.closest(".sheet-root");
      if (sheet) {
        e.preventDefault();
        closeSheet(sheet);
      }
    }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      document.querySelectorAll(".sheet-root.is-open").forEach(closeSheet);
    }
  });

  // ─── Loading sequence ───
  const progressEl = $("[data-progress]");
  const loadingLabel = $("[data-loading-label]");
  const loadingIcon = $("[data-loading-icon]");
  const STEPS = [
    { at: 25, label: "Loading market data…" },
    { at: 55, label: "Tuning AI matches…" },
    { at: 85, label: "Personalizing feed…" },
    { at: 100, label: "Ready ✓", done: true },
  ];
  let pct = 0;
  let stepIdx = 0;
  const tickProgress = () => {
    pct = Math.min(100, pct + (Math.random() * 6 + 4));
    if (progressEl) progressEl.style.width = pct + "%";
    const next = STEPS[stepIdx];
    if (next && pct >= next.at) {
      if (loadingLabel) loadingLabel.textContent = next.label;
      if (next.done) {
        if (loadingIcon) {
          loadingIcon.classList.remove("ph-circle-notch", "animate-spin");
          loadingIcon.classList.add("ph-fill", "ph-check-circle", "text-brand");
        }
        return;
      }
      stepIdx++;
    }
    if (pct < 100) setTimeout(tickProgress, 220);
  };
  setTimeout(tickProgress, 350);

  // ─── Theme toggle ───
  const themeBtn = $("[data-theme-toggle]");
  const themeIcon = $("[data-theme-icon]");
  const repaintTheme = () => {
    const isLight =
      document.documentElement.getAttribute("data-theme") === "light";
    if (themeIcon) {
      themeIcon.className = isLight
        ? "ph-fill ph-sun"
        : "ph-fill ph-moon-stars";
    }
  };
  repaintTheme();
  themeBtn?.addEventListener("click", () => {
    // app.js document-level handler fires after this and applies the toggle.
    // Use setTimeout(0) so the toast reads the already-updated theme state.
    setTimeout(() => {
      repaintTheme();
      const isLight =
        document.documentElement.getAttribute("data-theme") === "light";
      toast(isLight ? "Light theme" : "Dark theme");
    }, 0);
  });

  // ─── Language picker ───
  const langBtn = $("[data-lang]");
  const langLabel = $("[data-lang-label]");
  langBtn?.addEventListener("click", () => {
    openSheet(document.getElementById("langSheet"));
  });
  $$("[data-lang-pick]").forEach((b) => {
    b.addEventListener("click", () => {
      const code = b.getAttribute("data-lang-pick");
      const name = b.getAttribute("data-lang-name");
      $$("[data-lang-check]").forEach((c) => c.classList.add("hidden"));
      const check = document.querySelector(`[data-lang-check="${code}"]`);
      if (check) check.classList.remove("hidden");
      if (langLabel) langLabel.textContent = code;
      const sheet = $("#langSheet");
      if (sheet) closeSheet(sheet);
      toast(`Language: ${name}`);
    });
  });
});
